import { analyticsService } from '@/services/analyticsService';

class ErrorMonitoringService {
  private installed = false;

  install(): void {
    if (this.installed || typeof window === 'undefined') {
      return;
    }
    window.addEventListener('error', this.handleError);
    window.addEventListener('unhandledrejection', this.handleRejection);
    this.installed = true;
  }

  uninstall(): void {
    if (!this.installed || typeof window === 'undefined') {
      return;
    }
    window.removeEventListener('error', this.handleError);
    window.removeEventListener('unhandledrejection', this.handleRejection);
    this.installed = false;
  }

  private handleError = (event: ErrorEvent): void => {
    analyticsService.trackError(event.error ?? event.message, {
      source: 'window.error',
      filename: event.filename,
      lineno: event.lineno,
      colno: event.colno
    });
  };

  private handleRejection = (event: PromiseRejectionEvent): void => {
    analyticsService.trackError(event.reason, {
      source: 'unhandledrejection'
    });
  };
}

export const errorMonitoringService = new ErrorMonitoringService();

